// Matches FrontDoor.Button writing style (e.g. "Video to animation").
export const PANEL_WRITING_VARIANT = 'studio/body/medium/sm' as const;
export const PANEL_WRITING_CLASSNAME = 'text-gray-90 dark:text-white';
